import React, { Component } from "react";

import Api from "../../../../../lib/componentApi";
import { GlobalConsumer } from "../../../../../context/GlobalContext";

export default class DeleteItem extends Component {
  constructor(props) {
    super(props);
  }
  handleDeleteItem = updateBasket => {
    const { closeDefaultStatus, item } = this.props;
    const basketItemId = item.id;
    const quantity = item.quantity;
    Api.post(
      "/api/product/item/delete",
      { basketItemId, quantity },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          //item not found && empty basket
          updateBasket(null, true);
          if (response.code === 4030 || response.code === 4029) {
            closeDefaultStatus("deleteItem");
          } else {
            console.log(response.code, "delete-item-code");
          }
        } else {
          if (response.status) {
            updateBasket(response.basket);
          } else {
            console.log("response status false delete basket item");
          }
          closeDefaultStatus("deleteItem");
        }
      }
    );
  };
  render() {
    const { closeDefaultStatus } = this.props;
    return (
      <React.Fragment>
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a href="javascript: void(0)" />
              <h4>Delete</h4>
              <a
                href="javascript: void(0)"
                onClick={() => closeDefaultStatus("deleteItem")}
                className="close"
              >
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-8">
                  <div className="delete-checkout-item white-bg">
                    <p>Are you sure you want to delete this product?</p>
                  </div>
                  <GlobalConsumer>
                    {({ updateBasket }) => (
                      <div className="use-buttons d-flex align-items-center">
                        <button
                          className="btn btn-red"
                          onClick={() => this.handleDeleteItem(updateBasket)}
                        >
                          Delete
                        </button>
                        <button
                          className="btn btn-gray"
                          onClick={() => closeDefaultStatus("deleteItem")}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </GlobalConsumer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
